import { gql } from '@apollo/client';

export const organizationFields = gql`
  fragment AdminOrganizationFields on Organization {
    name
    publicId
    billingEmail
    discount
    addOnDiscount
    stripeCustomerId
    createdAt
    discardedAt
    hubspotDealId
    planSet {
      id
    }
    venues {
      id
      name
      discardedAt
    }
    users {
      id
      role
      email
      firstName
      lastName
      magicLoginLink
    }
    featureFlags
  }
`;

export const updateOrganizationMutation = gql`
  mutation UpdateAdminOrganization($input: AdminUpdateOrganizationInput!) {
    adminUpdateOrganization(input: $input) {
      organization {
        id
        ...AdminOrganizationFields
      }
      errors {
        message
      }
    }
  }
  ${organizationFields}
`;

const hubspotOwnerFields = gql`
  fragment HubspotOwnerFields on HubspotOwner {
    hubspotOwnerId
    email
    firstName
    lastName
    admin {
      id
      email
    }
  }
`;

export const getHubspotOwnersQuery = gql`
  query HubspotOwners($organizationId: ID!) {
    hubspotOwners(organizationId: $organizationId) {
      dealOwner {
        ...HubspotOwnerFields
      }
      companyOwner {
        ...HubspotOwnerFields
      }
      onboardingOwner {
        ...HubspotOwnerFields
      }
      accountManagementOwner {
        ...HubspotOwnerFields
      }
      error
    }
  }
  ${hubspotOwnerFields}
`;

export const organizationQuery = gql`
  query AdminOrganization($id: ID!) {
    organization(id: $id) {
      id
      ...AdminOrganizationFields
    }
    adminPlanSets {
      id
      name
      planDefinitions {
        id
        planName
        monthlyRate
        billingInterval
        stripeProductId
        stripePriceId
        cardApplicationFeeRate
        achApplicationFeeRate
        tier
        active
      }
    }
  }
  ${organizationFields}
`;
